import { useRef, useState } from "react";
import { FaPlay } from "react-icons/fa";

const VIDEO_ID = "I0SCOJy5McA";

const THUMBNAILS = [
  "/hero-poster.webp",
  `https://i.ytimg.com/vi/${VIDEO_ID}/maxresdefault.jpg`,
  `https://i.ytimg.com/vi/${VIDEO_ID}/sddefault.jpg`,
  `https://i.ytimg.com/vi/${VIDEO_ID}/hqdefault.jpg`,
];

const HeroVideoPlayer = ({ className = "" }) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [thumbIdx, setThumbIdx] = useState(0);
  const imgRef = useRef(null);

  const showVideo = () => setIsPlaying(true);

  const advanceThumbnail = () => {
    if (thumbIdx === THUMBNAILS.length - 1) {
      showVideo();
      return;
    }
    setThumbIdx((index) => index + 1);
  };

  const handleThumbnailLoad = () => {
    if (imgRef.current && imgRef.current.naturalWidth <= 120) {
      advanceThumbnail();
    }
  };

  return (
    <div className={`relative aspect-video w-full overflow-hidden bg-black ${className}`}>
      {!isPlaying ? (
        <button
          type="button"
          onClick={showVideo}
          aria-label="Play MK AI Technologies overview video"
          className="group absolute inset-0 flex h-full w-full items-center justify-center focus:outline-none focus-visible:ring-4 focus-visible:ring-inset focus-visible:ring-[#8B4AFA]"
        >
          <img
            key={THUMBNAILS[thumbIdx]}
            ref={imgRef}
            src={THUMBNAILS[thumbIdx]}
            alt="MK AI Technologies overview"
            width="1000"
            height="563"
            loading="eager"
            decoding="async"
            fetchPriority="high"
            className={`absolute inset-0 h-full w-full object-cover object-center ${
              thumbIdx > 0 ? "scale-[1.08]" : ""
            }`}
            onLoad={handleThumbnailLoad}
            onError={advanceThumbnail}
          />

          <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-black/35 via-black/5 to-transparent transition-colors duration-300 group-hover:bg-black/10" />

          {/* Play button */}
          <span className="relative z-10 flex h-16 w-16 items-center justify-center">
            <span
              aria-hidden="true"
              className="absolute inset-0 rounded-full bg-white/60 opacity-60 motion-safe:animate-ping motion-reduce:hidden"
            />
            <span className="relative flex h-16 w-16 items-center justify-center rounded-full bg-white shadow-xl transition-transform duration-300 ease-out group-hover:scale-105">
              <FaPlay className="h-6 w-6 translate-x-0.5 text-[#8B4AFA]" />
            </span>
          </span>
        </button>
      ) : (
        <iframe
          src={`https://www.youtube-nocookie.com/embed/${VIDEO_ID}?autoplay=1&rel=0&modestbranding=1&controls=1&playsinline=1`}
          title="MK AI Technologies Overview"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          className="absolute inset-0 h-full w-full border-0"
        />
      )}
    </div>
  );
};

export default HeroVideoPlayer;